export interface Camera {
  deviceId: string;
  name: string;
  height: number;
  width: number;
  frameRate: number;
  torch: boolean;
  recommended: boolean;
  facingMode: string;
  focusModes: string[];
}
